module.exports = __webpack_public_path__ + "static/media/favicon-exact.eab743b5.ico";